import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { HANDS, STAR_BREATHING_VO } from '../config/Config';
import { StarBreathingFollower } from '../display/StarBreathingFollower';
import { StarBreathingGuide } from '../display/StarBreathingGuide';
import { StarBreathingParticle } from '../display/StarBreathingParticle';
import { StarBreathingTrail } from '../display/StarBreathingTrail';
export class StateStarBreathingCopy extends SceneState {
  startState() {
    const pathConfig = HANDS.elmo;
    this.path = pathConfig.path.map((p, i) => ({
      ...p,
      distance: i == 0 ? 0 : Phaser.Math.Distance.BetweenPoints(pathConfig.path[i - 1], p),
      angle: i == 0 ? 0 : Phaser.Math.Angle.BetweenPoints(pathConfig.path[i - 1], p),
    }));

    this.hand = this.scene.add.image(910, 780, pathConfig.image.sheet, pathConfig.image.key);
    this.hand.setOrigin(0.5, 1);
    this.pathTrailStarBurst = new StarBreathingParticle(this.scene, 0, 0);

    this.followPath = false;
    this.starsReached = 0;

    this.scene.tweens.add({
      targets: this.hand,
      y: { from: 2000, to: 780 },
      duration: 250,
      onComplete: () => {
        this.scene.game.vo.playChain(STAR_BREATHING_VO.copy_start, {
          onComplete: () => this.playScene(),
        });
      },
      completeDelay: 500,
    });
  }

  playScene() {
    this.pathGuide = new StarBreathingGuide(this.scene, this.hand.x, this.hand.y, this.path);
    this.pathTrail = new StarBreathingTrail(this.scene, 0, 0);
    this.handPointer = this.scene.add.image(810, 360, 'star_breathing', 'pointer_elmo');
    this.handPointer.setOrigin(0.13, 0.5);
    this.pathGuide.renderPathGuideToStar(0);
    this.pathFollower = new StarBreathingFollower({
      path: this.path,
      offset: this.hand,
      target: this.handPointer,
      speed: 150,
    });

    this.hand.time = 0;
    this.scene.tweens.add({
      targets: this.hand,
      time: { from: 0, to: 1 },
      duration: 750,
      onComplete: () => {
        this.scene.game.vo.playChain(STAR_BREATHING_VO.breathe_in);
        this.followPath = true;
      },
    });
  }

  onSceneUpdate(time, delta) {
    if (this.followPath) {
      const { x, y } = this.handPointer;
      this.pathFollower.update(delta);
      this.pathTrail.addPoints({ x, y }, this.handPointer);
      this.pathGuide.renderPathGuideToStar(this.pathFollower.pathIndex);

      if (this.pathFollower.pathComplete) {
        this.handlePathTweenComplete();
      } else if (this.pathFollower.starReached) {
        this.handleStarReached(this.pathFollower.currentPoint);
      }
    }

    if (this.pathTrail) this.pathTrail.update(delta);
    if (this.pathTrailStarBurst) this.pathTrailStarBurst.update(delta);
  }

  handleStarReached(star) {
    this.starsReached++;
    this.scene.game.soundController.playSFX('sfx', 'star');
    this.pathFollower.clearCurrentStarPoint();
    this.pathGuide.clear();
    this.followPath = false;
    this.hand.time = 0;
    this.pathTrailStarBurst.addStars(10, star.x, star.y);
    this.scene.tweens.add({
      targets: this.hand,
      time: { from: 0, to: 1 },
      duration: 750,
      onComplete: () => {
        const vo =
          this.starsReached % 2 == 1 ? STAR_BREATHING_VO.breathe_out : STAR_BREATHING_VO.breathe_in;
        this.scene.game.vo.playChain(vo);

        this.followPath = true;
      },
    });
  }
  handlePathTweenComplete() {
    this.pathGuide.clear();
    this.followPath = false;

    this.scene.game.vo.playChain(STAR_BREATHING_VO.complete, {
      onComplete: () => {
        this.scene.tweens.add({
          targets: this.handPointer,
          alpha: 0,
          duration: 100,
        });
        this.scene.tweens.add({
          targets: this.hand,
          y: 2000,
          duration: 500,
          delay: 1000,
          onComplete: () => this.emit('state_complete'),
        });
      },
    });
  }

  endState() {
    this.scene.game.vo.stop();
    this.pathFollower = null;
    this.removeSceneObject('pathTrail');
    this.removeSceneObject('pathGuide');
    this.removeSceneObject('hand');
    this.removeSceneObject('handPointer');
  }

  removeSceneObject(id) {
    if (this[id]) {
      this.scene.tweens.killTweensOf(this[id]);
      this[id].destroy();
      this[id] = null;
    }
  }
}
